import React, { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import ReactStrapModal from './Modal'
import './EventForm.scss'
import { Col, Row, Button } from 'reactstrap'

import isEmpty from 'lodash/isEmpty'
import { getFrench } from './FrenchTranslation'
import { makeGetRequest } from 'utils/api'
import { makePutRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'
import { Checkbox, FormControl, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material'
import urls from 'utils/urls'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const SignupForm = ({
  isOpen,
  toggleModal,
  title,
  editMode = false,
  eventId = '',
  slot,
  getAllEvents,
}) => {
  const [categoryDD, setCategoryDD] = useState([])
  const [typeDD, setTypeDD] = useState([])
  const [value, setValue] = useState({})
  const [showStartDate, setShowStartDate] = useState(!editMode)
  const [showStartTime, setShowStartTime] = useState(!editMode)
  const [showEndDate, setShowEndDate] = useState(!editMode)
  const [showEndTime, setShowEndTime] = useState(!editMode)
  const [showLocation, setShowLocation] = useState(!editMode)
  const [showTitle, setShowTitle] = useState(!editMode)
  const [isPeriodic, setisPeriodic] = useState(false)
  const [isDaily, setisDaily] = useState(false)
  const [isMonthly, setisMonthly] = useState(false)
  const [isWeekly, setisWeekly] = useState(false)
  const [isYearly, setisYearly] = useState(false)
  const [personName, setPersonName] = React.useState([])
  const [contacts, setContacts] = useState([])
  
  // LAP-614: Push to external calendars
  const [connectedAccounts, setConnectedAccounts] = useState([])
  const [pushToCalendars, setPushToCalendars] = useState({
    Google: false,
    Microsoft: false,
    iCloud: false,
  })

  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    )

    formik.setFieldValue('participants', typeof value === 'string' ? value.split(',') : value)
  }

  useEffect(() => {
    // console.log(isOpen)
    getData()
    fetchContacts()
    fetchConnectedAccounts() // LAP-614
  }, [])
  const fetchContacts = async () => {
    const url = urls.getAllContacts + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Nom} ${v.Prenom}`, id: v.id })
      })
      setContacts([...filterTypes])
    }
  }
  
  // LAP-614: Fetch connected calendar accounts with push enabled
  const fetchConnectedAccounts = async () => {
    try {
      const { data, status } = await makeGetRequest('/api/user/calendar-accounts/', {}, true)
      if (status === 200) {
        // Filter only accounts with push enabled
        const enabledAccounts = data.filter(
          (acc) => acc.sync_out_enabled && acc.status && !acc.temoin_darchivage
        )
        setConnectedAccounts(enabledAccounts)
        
        // Set default push state (all enabled by default)
        const defaultPush = {}
        enabledAccounts.forEach((acc) => {
          defaultPush[acc.acc_type] = true
        })
        setPushToCalendars(defaultPush)
      }
    } catch (error) {
      console.error('Error fetching connected accounts:', error)
    }
  }
  
  const getData = async () => {
    const { data = {} } = await makeGetRequest('/api/time/get-category-dd', {}, true)
    setCategoryDD(data)
  }
  const validate = (values) => {
    const errors = {}
    if (!values.titre) {
      errors.titre = 'Required'
    } else if (values.titre.length > 255) {
      errors.titre = 'Must be 255 characters or less'
    }

    if (!values.category_id) {
      errors.category_id = 'Required'
    }
    if (!values.lieux) {
      // errors.lieux = 'Required'
    } else if (values.lieux.length > 50) {
      errors.lieux = 'Must be 20 characters or less'
    }

    if (!values.start_date) {
      errors.start_date = 'Required'
    }

    if (!values.end_date) {
      errors.end_date = 'Required'
    }
    return errors
  }
  useEffect(() => {
    const uFunction = async () => {
      if (editMode) {
        const { data, status } = await makeGetRequest(`/api/time/events/${eventId}`, {}, true)
        const {
          start_date = '',
          end_date = '',
          start_time = null,
          end_time = null,
          titre = '',
          lieux = '',
          is_all_day = false,
          category_id = '',
          type_id = '',
          participants = '',
          saturday = false,
          sunday = false,
          monday = false,
          tuesday = false,
          wednesday = false,
          thursday = false,
          friday = false,
          repeat_on_month = '',
          repeat_after = '',
          repeat_on = '',
          is_daily = false,
          is_weekly = false,
          is_monthly = false,
          is_yearly = false,
          is_occurrences = false,
          number_of_occurrences = '',
          is_periodic = false,
          is_no_end_date = false,
          is_repeat_daily = false,
          frequency_end_date = '',
        } = data

        let sDate = start_date ? start_date.substring(0, 2) : ''
        let sMonth = start_date ? start_date.substring(3, 5) : ''
        let sYear = start_date ? start_date.substring(6, 10) : ''

        const startDate = `${sYear}-${sMonth}-${sDate}`

        let eDate = end_date ? end_date.substring(0, 2) : ''
        let eMonth = end_date ? end_date.substring(3, 5) : ''
        let eYear = end_date ? end_date.substring(6, 10) : ''

        const endDate = `${eYear}-${eMonth}-${eDate}`

        let fDate = frequency_end_date ? frequency_end_date.substring(0, 2) : ''
        let fMonth = frequency_end_date ? frequency_end_date.substring(3, 5) : ''
        let fYear = frequency_end_date ? frequency_end_date.substring(6, 10) : ''

        const freqDate = `${fYear}-${fMonth}-${fDate}`

        setValue({
          start_date: startDate,
          end_date: endDate,
          start_time: start_time,
          end_time: end_time,
          titre: titre,
          lieux: lieux,
          is_all_day: is_all_day,
          category_id: category_id,
          type_id: type_id,
          participants: participants,
          saturday: saturday,
          sunday: sunday,
          monday: monday,
          tuesday: tuesday,
          wednesday: wednesday,
          thursday: thursday,
          friday: friday,
          is_periodic: is_periodic,
          repeat_on_month: repeat_on_month,
          repeat_after: repeat_after,
          repeat_on: repeat_on,
          is_daily: is_daily,
          is_weekly: is_weekly,
          is_monthly: is_monthly,
          is_yearly: is_yearly,
          is_occurrences: is_occurrences,
          number_of_occurrences: number_of_occurrences,
          is_no_end_date: is_no_end_date,
          is_repeat_daily: is_repeat_daily,
          frequency_end_date: isEmpty(frequency_end_date) ? null : freqDate,
          is_freq_end_date: isEmpty(frequency_end_date) ? false : true,
        })
        setisPeriodic(is_periodic)
        setisDaily(is_daily)
        setisWeekly(is_weekly)
        setisMonthly(is_monthly)
        setisYearly(is_yearly)
        setPersonName(participants)
      } else if (!isEmpty(slot)) {
        const { start, end } = slot

        let sDate = start ? start.getDate() : ''
        let sMonth = start ? start.getMonth() + 1 : ''
        let sYear = start ? start.getFullYear() : ''
        let sHour = start ? start.getHours() : ''
        let sMinute = start ? start.getMinutes() : ''
        sMonth = sMonth < 10 ? `0${sMonth}` : sMonth
        sDate = sDate < 10 ? `0${sDate}` : sDate
        sHour = sHour < 10 ? `0${sHour}` : sHour
        sMinute = sMinute < 10 ? `0${sMinute}` : sMinute
        const startDate = `${sYear}-${sMonth}-${sDate}`

        let eDate = end ? end.getDate() : ''
        let eMonth = end ? end.getMonth() + 1 : ''
        let eYear = end ? end.getFullYear() : ''
        let eHour = end ? end.getHours() : ''
        let eMinute = end ? end.getMinutes() : ''
        eMonth = eMonth < 10 ? `0${eMonth}` : eMonth
        eDate = eDate < 10 ? `0${eDate}` : eDate
        eHour = eHour < 10 ? `0${eHour}` : eHour
        eMinute = eMinute < 10 ? `0${eMinute}` : eMinute
        const endDate = `${eYear}-${eMonth}-${eDate}`

        setValue({
          start_date: startDate,
          end_date: endDate,
          start_time: `${sHour}:${sMinute}`,
          end_time: `${eHour}:${eMinute}`,
          titre: '',
          lieux: '',
          is_all_day: false,
          category_id: '',
          type_id: '',
          participants: [],
          saturday: false,
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          is_yearly: false,
          is_monthly: false,
          is_daily: false,
          is_weekly: false,
          is_periodic: false,
          repeat_on_month: null,
        })
      } else {
        setValue({
          start_date: '',
          end_date: '',
          start_time: null,
          end_time: null,
          titre: '',
          lieux: '',
          is_all_day: false,
          category_id: '',
          type_id: '',
          participants: [],
          saturday: false,
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          is_yearly: false,
          is_monthly: false,
          is_daily: false,
          is_weekly: false,
          is_periodic: false,
          repeat_on_month: null,
        })
      }
    }
    uFunction()
  }, [])
  // console.log(value)
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: value,
    validate,
    onSubmit: async (values) => {
      // console.log(values)
      let payload = { ...values }
      // if (payload.category_id) {
      //   let selectedCat = categoryDD.filter((e) => e.id === parseInt(payload.category_id))
      //   let scatefscat = selectedCat[0].type.filter((e) => e.id === parseInt(payload.type_id))
      //   payload.category_id = '' + scatefscat[0].cat
      // }
      if (editMode) {
        const response = await makePutRequest(`/api/time/events/${eventId}/`, payload, {}, true)
        if (response.status === 200) {
          // window.location.reload()
          if (getAllEvents) {
            getAllEvents()
          }
          toggleModal()
        } else {
          toggleModal()
        }
      } else {
        // console.log(payload)
        // return
        const response = await makePostRequest('/api/time/events/', payload, {}, true)
        if (response.status === 201) {
          // LAP-614: Immediate push to selected external calendars
          const createdEvent = response.data
          const selectedCalendars = Object.keys(pushToCalendars).filter(
            (key) => pushToCalendars[key]
          )
          
          if (selectedCalendars.length > 0) {
            console.log(`[LAP-614] Pushing event to: ${selectedCalendars.join(', ')}`)
            
            // Push to each selected calendar
            for (const calendarType of selectedCalendars) {
              try {
                const pushResponse = await makePostRequest(
                  `/api/user/push-events-to-external/?calendar_type=${calendarType}`,
                  {},
                  {},
                  true
                )
                
                if (pushResponse.status === 200) {
                  console.log(
                    `[LAP-614] Pushed to ${calendarType}: ${pushResponse.data.successful} successful`
                  )
                } else {
                  console.error(`[LAP-614] Failed to push to ${calendarType}`)
                }
              } catch (error) {
                console.error(`[LAP-614] Error pushing to ${calendarType}:`, error)
              }
            }
          }
          
          getAllEvents()
          toggleModal()
        } else {
          toggleModal()
        }
      }
    },
  })

  const getTypeByCategory = (id) => {
    let types = categoryDD.find((x) => x.id.toString() === id)
    types && setTypeDD(types.type)
  }

  useEffect(() => {
    value && value.category_id && getTypeByCategory(value.category_id.toString())
  }, [value])

  return (
    <ReactStrapModal isOpen={isOpen} toggleModal={toggleModal} title={title} size="lg">
      <form
        onSubmit={formik.handleSubmit}
        style={{
          backgroundColor: 'white',
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
        }}
      >
        <Row>
          <Col md={2}>
            <label htmlFor="titre">Titre</label>
          </Col>
          <Col md={4}>
            {editMode && (
              <h6>
                {value.titre}{' '}
                <span style={{ color: 'blue', fontSize: '12px', cursor: 'pointer' }}>
                  <a onClick={() => setShowTitle(!showTitle)}>Éditer</a>
                </span>
              </h6>
            )}
            {showTitle && (
              <input
                required
                id="titre"
                name="titre"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.titre}
                placeholder={'Titre'}
              />
            )}
          </Col>
        </Row>
        {formik.errors.titre ? <div>{formik.errors.titre}</div> : null}
        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="lieux">Lieux</label>
          </Col>
          <Col md={4}>
            {editMode && (
              <h6>
                {value.lieux}{' '}
                <span style={{ color: 'blue', fontSize: '12px', cursor: 'pointer' }}>
                  <a onClick={() => setShowLocation(!showLocation)}>Éditer</a>
                </span>
              </h6>
            )}
            {showLocation && (
              <input
                id="lieux"
                name="lieux"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lieux}
                placeholder={'Lieux'}
              />
            )}
          </Col>
        </Row>
        {/* {formik.errors.lieux ? <div>{formik.errors.lieux}</div> : null} */}
        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="start_date">Date de début</label>
          </Col>
          <Col md={4}>
            {editMode && (
              <h6>
                {value.start_date}{' '}
                <span style={{ color: 'blue', fontSize: '12px', cursor: 'pointer' }}>
                  <a onClick={() => setShowStartDate(!showStartDate)}>Éditer</a>
                </span>
              </h6>
            )}
            {showStartDate && (
              <input
                id="start_date"
                name="start_date"
                type="date"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.start_date}
              />
            )}
          </Col>
        </Row>
        {formik.errors.start_date ? <div>{formik.errors.start_date}</div> : null}
        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="start_time">Heure de début</label>
          </Col>
          <Col md={4}>
            {editMode && (
              <h6>
                {value.start_time}{' '}
                <span style={{ color: 'blue', fontSize: '12px', cursor: 'pointer' }}>
                  <a onClick={() => setShowStartTime(!showStartTime)}>Éditer</a>
                </span>
              </h6>
            )}
            {showStartTime && (
              <input
                id="start_time"
                name="start_time"
                type="time"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.start_time}
              />
            )}
            {formik.errors.start_time ? <div>{formik.errors.start_time}</div> : null}
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="end_date">Date de fin</label>
          </Col>
          <Col md={4}>
            {editMode && (
              <h6>
                {value.end_date}{' '}
                <span style={{ color: 'blue', fontSize: '12px', cursor: 'pointer' }}>
                  <a onClick={() => setShowEndDate(!showEndDate)}>Éditer</a>
                </span>
              </h6>
            )}
            {showEndDate && (
              <input
                id="end_date"
                name="end_date"
                type="date"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.end_date}
              />
            )}
          </Col>
        </Row>
        {formik.errors.end_date ? <div>{formik.errors.end_date}</div> : null}

        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="end_time">Heure de fin</label>
          </Col>
          <Col md={4}>
            {editMode && (
              <h6>
                {value.end_time}{' '}
                <span style={{ color: 'blue', fontSize: '12px', cursor: 'pointer' }}>
                  <a onClick={() => setShowEndTime(!showEndTime)}>Éditer</a>
                </span>
              </h6>
            )}
            {showEndTime && (
              <input
                id="end_time"
                name="end_time"
                type="time"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.end_time}
              />
            )}
          </Col>
        </Row>
        {formik.errors.end_time ? <div>{formik.errors.end_time}</div> : null}
        <br />

        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="is_periodic">{getFrench('is_periodic')}</label>
          </Col>
          <Col md={4}>
            <input
              id="is_periodic"
              name="is_periodic"
              type="checkbox"
              onChange={(e) => {
                formik.handleChange(e)
                formik.setFieldValue('is_periodic', e.target.checked)
                setisPeriodic(e.target.checked)
                if (!e.target.checked) {
                  setisDaily(false)
                  setisMonthly(false)
                  setisWeekly(false)
                  setisYearly(false)
                }
              }}
              onBlur={formik.handleBlur}
              checked={formik.values.is_periodic}
              className="chckbox"
            />
          </Col>
        </Row>
        {isPeriodic && (
          <>
            <hr />
            <p>Périodicité</p>{' '}
            <Row>
              <Col md={3}>
                <input
                  id="is_daily"
                  name="is_daily"
                  type="checkbox"
                  onChange={(e) => {
                    formik.handleChange(e)
                    setisDaily(e.target.checked)
                    setisMonthly(false)
                    setisWeekly(false)
                    setisYearly(false)
                    formik.setFieldValue('is_daily', e.target.checked)
                    formik.setFieldValue('is_weekly', false)
                    formik.setFieldValue('is_monthly', false)
                    formik.setFieldValue('is_yearly', false)
                  }}
                  onBlur={formik.handleBlur}
                  checked={formik.values.is_daily}
                  className="chckbox"
                />
                <label htmlFor="is_daily">{getFrench('is_daily')}</label>
              </Col>
              <Col md={3}>
                <input
                  id="is_weekly"
                  name="is_weekly"
                  type="checkbox"
                  onChange={(e) => {
                    formik.handleChange(e)
                    setisWeekly(e.target.checked)
                    setisMonthly(false)
                    setisDaily(false)
                    setisYearly(false)
                    formik.setFieldValue('is_weekly', e.target.checked)
                    formik.setFieldValue('is_daily', false)
                    formik.setFieldValue('is_monthly', false)
                    formik.setFieldValue('is_yearly', false)
                  }}
                  onBlur={formik.handleBlur}
                  checked={formik.values.is_weekly}
                  className="chckbox"
                />
                <label htmlFor="is_weekly">{getFrench('is_weekly')}</label>
              </Col>
              <Col md={3}>
                <input
                  id="is_monthly"
                  name="is_monthly"
                  type="checkbox"
                  onChange={(e) => {
                    formik.handleChange(e)
                    setisMonthly(e.target.checked)
                    setisDaily(false)
                    setisWeekly(false)
                    setisYearly(false)
                    formik.setFieldValue('is_monthly', e.target.checked)
                    formik.setFieldValue('is_weekly', false)
                    formik.setFieldValue('is_daily', false)
                    formik.setFieldValue('is_yearly', false)
                  }}
                  onBlur={formik.handleBlur}
                  checked={formik.values.is_monthly}
                  className="chckbox"
                />
                <label htmlFor="is_monthly">{getFrench('is_monthly')}</label>
              </Col>
              <Col md={3}>
                <input
                  id="is_yearly"
                  name="is_yearly"
                  type="checkbox"
                  onChange={(e) => {
                    formik.handleChange(e)
                    setisYearly(e.target.checked)
                    setisMonthly(false)
                    setisWeekly(false)
                    setisDaily(false)
                    formik.setFieldValue('is_yearly', e.target.checked)
                    formik.setFieldValue('is_weekly', false)
                    formik.setFieldValue('is_monthly', false)
                    formik.setFieldValue('is_daily', false)
                  }}
                  onBlur={formik.handleBlur}
                  checked={formik.values.is_yearly}
                  className="chckbox"
                />
                <label htmlFor="is_yearly">{getFrench('is_yearly')}</label>
              </Col>
            </Row>
            <hr />
          </>
        )}

        {isDaily && (
          <>
            <Row>
              <Col md={6}>
                <input
                  id="is_repeat_after"
                  name="is_repeat_after"
                  type="checkbox"
                  onChange={(e) => {
                    formik.handleChange(e)
                    formik.setFieldValue('is_repeat_daily', !e.target.checked)
                  }}
                  onBlur={formik.handleBlur}
                  checked={
                    formik.values.repeat_after && formik.values.is_repeat_daily === false
                      ? true
                      : false
                  }
                  className="chckbox"
                />
                <label htmlFor="is_repeat_after">{'Tous Les'}</label>{' '}
                <input
                  name="repeat_after_every"
                  type={'number'}
                  min={1}
                  onChange={(e) => {
                    formik.setFieldValue('is_repeat_after', true)
                    formik.setFieldValue('is_repeat_daily', false)
                    formik.setFieldValue('repeat_after', e.target.value)
                  }}
                  value={formik.values.is_repeat_daily === true ? '' : formik.values.repeat_after}
                />{' '}
                <label htmlFor="is_repeat_after">{'Jour(s)'}</label>
              </Col>
              <Col md={6}>
                <input
                  id="is_repeat_daily"
                  name="is_repeat_daily"
                  type="checkbox"
                  onChange={(e) => {
                    formik.handleChange(e)
                    formik.setFieldValue('is_repeat_daily', e.target.checked)
                    formik.setFieldValue('is_repeat_after', !e.target.checked)
                    formik.setFieldValue('repeat_after', 1)
                  }}
                  onBlur={formik.handleBlur}
                  checked={formik.values.is_repeat_daily}
                  className="chckbox"
                />
                <label htmlFor="is_repeat_daily">{'Tous les jours de semaine'}</label>{' '}
              </Col>
            </Row>
            <hr />
          </>
        )}

        {isWeekly && (
          <>
            <Row>
              <Col md={12}>
                <label htmlFor="is_repeat_after">{'Toutes les'}</label>{' '}
                <input
                  name="repeat_after_every"
                  type={'number'}
                  min={1}
                  onChange={(e) => {
                    formik.setFieldValue('repeat_after', e.target.value)
                  }}
                  value={formik.values.repeat_after}
                />{' '}
                <label htmlFor="is_repeat_after">{'semaine(s) le:'}</label>
              </Col>
              <br />
              <br />
              <Col>
                <Col md={12}>
                  <input
                    id="saturday"
                    name="saturday"
                    type="checkbox"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.saturday}
                    className="chckbox"
                  />
                  <label htmlFor="saturday">{getFrench('saturday')}</label>
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <input
                    id="sunday"
                    name="sunday"
                    type="checkbox"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.sunday}
                    className="chckbox"
                  />
                  <label htmlFor="sunday">{getFrench('sunday')}</label>
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <input
                    id="monday"
                    name="monday"
                    type="checkbox"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.monday}
                    className="chckbox"
                  />
                  <label htmlFor="monday">{getFrench('monday')}</label>
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <input
                    id="tuesday"
                    name="tuesday"
                    type="checkbox"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.tuesday}
                    className="chckbox"
                  />
                  <label htmlFor="tuesday">{getFrench('tuesday')}</label>
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <input
                    id="wednesday"
                    name="wednesday"
                    type="checkbox"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.wednesday}
                    className="chckbox"
                  />
                  <label htmlFor="wednesday">{getFrench('wednesday')}</label>
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <input
                    id="thursday"
                    name="thursday"
                    type="checkbox"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.thursday}
                    className="chckbox"
                  />
                  <label htmlFor="thursday">{getFrench('thursday')}</label>
                  <span style={{ marginLeft: '15px' }}>{''}</span>
                  <input
                    id="friday"
                    name="friday"
                    type="checkbox"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.friday}
                    className="chckbox"
                  />
                  <label htmlFor="friday">{getFrench('friday')}</label>
                </Col>
              </Col>
            </Row>
            <hr />
          </>
        )}
        {isMonthly && (
          <>
            <Row>
              <Col md={12}>
                <label htmlFor="repeat_on">{'Le'}</label>
                <span style={{ marginLeft: '10px' }}>{''}</span>
                <input
                  name="repeat_on"
                  type={'number'}
                  min={1}
                  onChange={(e) => {
                    formik.handleChange(e)
                  }}
                  value={formik.values.repeat_on}
                />{' '}
                <label htmlFor="repeat_after">{'Tous Les'}</label>
                <span style={{ marginLeft: '15px' }}>{''}</span>
                <input
                  name="repeat_after"
                  type={'number'}
                  min={1}
                  onChange={(e) => {
                    formik.handleChange(e)
                  }}
                  value={formik.values.repeat_after}
                />
                <span style={{ marginLeft: '15px' }}>{''}</span>
                <label htmlFor="repeat_after">{'Mois'}</label>
              </Col>
            </Row>
            <hr />
          </>
        )}
        {isYearly && (
          <>
            <Row>
              <Col md={12}>
                <label>{'Toutes les'}</label>
                <span style={{ marginLeft: '10px' }}>{''}</span>
                <input
                  name="repeat_after"
                  type={'number'}
                  min={1}
                  onChange={(e) => {
                    formik.handleChange(e)
                  }}
                  value={formik.values.repeat_after}
                />{' '}
                <label>{'an(s)'}</label>
              </Col>
              <br />
              <br />
              <Col md={12}>
                <label>{'Le:'}</label>
                <span style={{ marginLeft: '15px' }}>{''}</span>
                <input
                  name="repeat_on"
                  type={'number'}
                  min={1}
                  onChange={(e) => {
                    formik.handleChange(e)
                  }}
                  value={formik.values.repeat_on}
                />
                <span style={{ marginLeft: '15px' }}>{''}</span>
                <select
                  id="repeat_on_month"
                  name="repeat_on_month"
                  type="select"
                  onChange={(e) => {
                    formik.handleChange(e)
                    formik.setFieldValue('repeat_on_month', e.target.value)
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.repeat_on_month}
                >
                  <option value={1}>{getFrench(1)}</option>
                  <option value={2}>{getFrench(2)}</option>
                  <option value={3}>{getFrench(3)}</option>
                  <option value={4}>{getFrench(4)}</option>
                  <option value={5}>{getFrench(5)}</option>
                  <option value={6}>{getFrench(6)}</option>
                  <option value={7}>{getFrench(7)}</option>
                  <option value={8}>{getFrench(8)}</option>
                  <option value={9}>{getFrench(9)}</option>
                  <option value={10}>{getFrench(10)}</option>
                  <option value={11}>{getFrench(11)}</option>
                  <option value={12}>{getFrench(12)}</option>
                </select>
              </Col>
            </Row>
            <hr />
          </>
        )}

        {(isDaily || isWeekly || isMonthly || isYearly) && (
          <>
            <Row>
              <p>{'Plage de périodicité'}</p>
              <Col md={12}>
                <label>{'Début'}</label>
                <span style={{ marginLeft: '15px' }}>{''}</span>
                <input
                  disabled
                  id="start_date"
                  name="start_date"
                  type="date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.start_date}
                />
              </Col>
              <br />
              <br />

              <Col md={12}>
                <input
                  id="is_freq_end_date"
                  name={'is_freq_end_date'}
                  type={'checkbox'}
                  className="chckbox"
                  onChange={(e) => {
                    formik.handleChange(e)
                    formik.setFieldValue('is_freq_end_date', true)
                    formik.setFieldValue('is_occurrences', false)
                    formik.setFieldValue('is_no_end_date', false)
                  }}
                  checked={formik.values.is_freq_end_date}
                />
                <label>{'Fin le'}</label>
                <span style={{ marginLeft: '8px' }}>{''}</span>
                <input
                  id="frequency_end_date"
                  name="frequency_end_date"
                  type="date"
                  onChange={(e) => {
                    formik.handleChange(e)
                    formik.setFieldValue('is_freq_end_date', true)
                    formik.setFieldValue('is_occurrences', false)
                    formik.setFieldValue('is_no_end_date', false)
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.frequency_end_date}
                />
                <span style={{ marginLeft: '20px' }}>{''}</span>
                <input
                  id="is_occurrences"
                  name={'is_occurrences'}
                  type={'checkbox'}
                  className="chckbox"
                  checked={formik.values.is_occurrences}
                  onChange={(e) => {
                    formik.handleChange(e)
                    formik.setFieldValue('is_freq_end_date', false)
                    formik.setFieldValue('frequency_end_date', null)
                    formik.setFieldValue('is_occurrences', true)
                    formik.setFieldValue('is_no_end_date', false)
                  }}
                />
                <label htmlFor="is_occurrences">{'Fin apres:'}</label>
                <span style={{ marginLeft: '8px' }}>{''}</span>
                <input
                  id="number_of_occurrences"
                  name="number_of_occurrences"
                  type="number"
                  min={1}
                  onChange={(e) => {
                    formik.handleChange(e)
                    formik.setFieldValue('is_freq_end_date', false)
                    formik.setFieldValue('is_occurrences', true)
                    formik.setFieldValue('is_no_end_date', false)
                  }}
                  onBlur={formik.handleBlur}
                  value={
                    formik.values.number_of_occurrences === 0
                      ? ''
                      : formik.values.number_of_occurrences
                  }
                />
                <span style={{ marginLeft: '6px' }}>{''}</span>
                <label htmlFor="number_of_occurrences">{'occurrences'}</label>
                <br />
                <br />
                <input
                  id="is_no_end_date"
                  name={'is_no_end_date'}
                  type={'checkbox'}
                  className="chckbox"
                  onChange={(e) => {
                    formik.handleChange(e)
                    formik.setFieldValue('number_of_occurrences', 0)
                    formik.setFieldValue('is_freq_end_date', false)
                    formik.setFieldValue('is_occurrences', false)
                    formik.setFieldValue('is_no_end_date', true)
                    formik.setFieldValue('frequency_end_date', null)
                  }}
                  checked={formik.values.is_no_end_date}
                />
                <label htmlFor="is_no_end_date">{'Pas De Date De Fin'}</label>
              </Col>
            </Row>
            <hr />
          </>
        )}
        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="is_all_day">Journée entière</label>
          </Col>
          <Col md={4}>
            <input
              id="is_all_day"
              name="is_all_day"
              type="checkbox"
              checked={formik.values.is_all_day}
              onChange={(e) => {
                formik.handleChange(e)

                formik.setFieldValue('start_time', '00:00')
                formik.setFieldValue('end_time', '23:59')
              }}
              onBlur={formik.handleBlur}
              value={formik.values.is_all_day}
              className="chckbox"
            />
          </Col>
        </Row>
        {formik.errors.is_all_day ? <div>{formik.errors.is_all_day}</div> : null}

        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="category_id">Categorie</label>
          </Col>
          <Col md={4}>
            <select
              id="category_id"
              name="category_id"
              type="select"
              required
              onChange={(e) => {
                formik.handleChange(e)
                getTypeByCategory(e.target.value)
              }}
              onBlur={formik.handleBlur}
              value={formik.values.category_id}
            >
              <option value={''}>Select categorie</option>
              {categoryDD &&
                categoryDD.map((cat) => {
                  return (
                    <option key={cat.id} value={cat.id.toString()}>
                      {cat.name}
                    </option>
                  )
                })}
            </select>
          </Col>
        </Row>
        {formik.errors.category_id ? <div>{formik.errors.category_id}</div> : null}
        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="type_id">Type</label>
          </Col>
          <Col md={4}>
            <select
              id="type_id"
              name="type_id"
              type="select"
              onLoad={() => value.category_id && getTypeByCategory(value.category_id.toString())}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.type_id}
            >
              <option value={''}>Select Type</option>
              {typeDD &&
                typeDD.map((type) => {
                  return (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  )
                })}
            </select>
          </Col>
        </Row>
        {formik.errors.type_id ? <div>{formik.errors.type_id}</div> : null}

        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="participants">Participants</label>
          </Col>
          <Col md={4}>
            {/* <input
              id="participants"
              name="participants"
              type="participants"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.participants}
              placeholder={'Participants'}
            /> */}
            <FormControl sx={{ m: 1, width: 300 }}>
              <Select
                id="participants"
                name="participants"
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="" />}
                renderValue={(selected) =>
                  selected
                    .map(
                      (id) => contacts.length > 0 && contacts.find((name) => name.id === id).label,
                    )
                    .join(', ')
                }
                MenuProps={MenuProps}
                size="small"
                sx={{ width: '226px' }}
              >
                {contacts.map((v) => (
                  <MenuItem key={v.id} value={v.id}>
                    <Checkbox checked={personName.includes(v.id)} />
                    <ListItemText primary={v.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Col>
        </Row>
        {formik.errors.participants ? <div>{formik.errors.participants}</div> : null}

        {/* LAP-614: Push to External Calendars */}
        {connectedAccounts.length > 0 && (
          <>
            <br />
            <Row>
              <Col md={2}>
                <label>Push to External</label>
              </Col>
              <Col md={10}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="radio"
                      id="push-none"
                      name="pushToCalendar"
                      checked={!Object.values(pushToCalendars).some(v => v)}
                      onChange={() => {
                        const resetCalendars = {}
                        connectedAccounts.forEach(acc => {
                          resetCalendars[acc.acc_type] = false
                        })
                        setPushToCalendars(resetCalendars)
                      }}
                      style={{ marginRight: '8px' }}
                    />
                    <label htmlFor="push-none" style={{ margin: 0, cursor: 'pointer' }}>
                      Don't push to external calendar
                    </label>
                  </div>
                  {connectedAccounts.map((account) => (
                    <div key={account.id} style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        type="radio"
                        id={`push-${account.acc_type}`}
                        name="pushToCalendar"
                        checked={pushToCalendars[account.acc_type] || false}
                        onChange={() => {
                          const newCalendars = {}
                          connectedAccounts.forEach(acc => {
                            newCalendars[acc.acc_type] = acc.acc_type === account.acc_type
                          })
                          setPushToCalendars(newCalendars)
                        }}
                        style={{ marginRight: '8px' }}
                      />
                      <label
                        htmlFor={`push-${account.acc_type}`}
                        style={{ margin: 0, cursor: 'pointer' }}
                      >
                        Push to {account.acc_type} ({account.name})
                      </label>
                    </div>
                  ))}
                  <small style={{ color: '#666', marginTop: '4px' }}>
                    ℹ️ This event will be pushed immediately to the selected calendar after creation
                  </small>
                </div>
              </Col>
            </Row>
          </>
        )}

        <br />
        <Button type="cancel" color="danger" size="lg" onClick={() => toggleModal()}>
          Annuler
        </Button>
        <Button type="submit" size="lg" style={{ backgroundColor: '#5D86CC' }}>
          Soumettre
        </Button>
      </form>
    </ReactStrapModal>
  )
}

export default SignupForm
